if ( typeof StickyCartBar !== 'function' ) {

	class StickyCartBar extends HTMLElement {

		constructor(){
			super();

			this.thumbsHolder = this.querySelector('[data-js-sticky-cart-bar-thumbs]');
			this.countLabel = this.querySelector('[data-js-sticky-cart-bar-count]');
			this.totalLabel = this.querySelector('[data-js-sticky-cart-bar-total]');
			this.headerCount = document.querySelector('[data-header-cart-count]');
			this.headerTotal = document.querySelector('[data-header-cart-total]');

			this.querySelector('[data-js-sticky-cart-bar-open]').addEventListener('click', ()=>{
				const sidebar = document.getElementById('site-cart-sidebar');
				if ( sidebar && typeof sidebar.show === 'function' ) {
					sidebar.show();
				} else {
					window.location.href = KROWN.settings.routes.cart_url;
				}
			});

			this.refresh();

			if ( this.headerCount ) {
				new MutationObserver(this.refresh.bind(this)).observe(this.headerCount, {
					characterData: true, childList: true, subtree: true
				});
			}

		}

		refresh(){

			const count = this.headerCount ? ( parseInt(this.headerCount.textContent) || 0 ) : 0;

			this.classList.toggle('hide', count <= 0);

			if ( this.countLabel ) {
				/* fall back when the cart.mini_cart_item(s) locales are missing, so a theme that
					 hasn't got them yet still shows a count instead of breaking every add to cart */
				const template = count == 1 ? KROWN.settings.locales.cart_mini_item : KROWN.settings.locales.cart_mini_items;
				this.countLabel.textContent = template ? template.replace('{{ count }}', count) : `${count} ${count == 1 ? 'item' : 'items'}`;
			}

			if ( this.totalLabel && this.headerTotal ) {
				this.totalLabel.textContent = this.headerTotal.textContent;
			}

			if ( count > 0 ) {
				this.refreshThumbs();
			}

		}

		refreshThumbs(){
			fetch(`${KROWN.settings.routes.cart_url}.js`)
				.then(response => response.json())
				.then(cart => this.renderThumbs(cart.items))
				.catch(()=>{});
		}

		renderThumbs(items){

			if ( ! this.thumbsHolder ) return;

			const recentItems = items.slice(-2).reverse();
			const extraCount = items.length - recentItems.length;

			this.thumbsHolder.innerHTML = '';

			recentItems.forEach(item=>{

				const thumb = document.createElement('span');
				thumb.className = 'sticky-cart-bar__thumb';

				if ( item.image ) {
					const img = document.createElement('img');
					img.src = item.image;
					img.alt = '';
					img.width = 40;
					img.height = 40;
					img.loading = 'lazy';
					thumb.appendChild(img);
				}

				this.thumbsHolder.appendChild(thumb);

			});

			if ( extraCount > 0 ) {
				const more = document.createElement('span');
				more.className = 'sticky-cart-bar__thumb-more';
				more.textContent = `+${extraCount}`;
				this.thumbsHolder.appendChild(more);
			}

		}

	}

  if ( typeof customElements.get('sticky-cart-bar') == 'undefined' ) {
		customElements.define('sticky-cart-bar', StickyCartBar);
	}

}
